import { ContentBlockType } from '../jdscontentblock/interface';
import { IPROP_MAP } from '../../generators/modifyProps';
import type { JDSContentCardProps } from './generated';
import { ListBlockProps } from '../jdslistblock/logic';
import { ReactElement } from 'react';
import { resolvePropObjectKeys } from '../../utils/componenthelpers';
export interface CardProps
  extends ContentBlockType,
    Omit<
      JDSContentCardProps,
      | 'header'
      | 'image'
      | 'footer'
      | 'imageFocus'
      | 'primaryCTA'
      | 'secondaryCTA'
      | 'size'
      | 'caption'
      | 'children'
    > {
  /**
   * Image HTML tags. e.g. `<img>`
   * passing a JSX element is deprecated. pass the image source as as string
   */
  image?: JDSContentCardProps['image'] | JSX.Element;
  /**
   * The header of the card.
   * @deprecated
   * Use `title` instead
   */
  header?: ReactElement<ListBlockProps>;
  /**
   * The footer of the card
   *
   * Passing JSX.Element is deprecated. Please pass a string
   */
  footer?: JDSContentCardProps['footer'] | JSX.Element;
  /**
   * Horizontal orientation puts image and content side by side.
   */
  imageFocus?: 'center' | 'top' | 'right' | 'bottom' | 'left';
  /**
   * any component or text is supported. Passing multiple children is deprecated. If you need multiple children, wrap it in a div.
   */
  children?: React.ReactNode;
}

export const PROP_MAP: IPROP_MAP<CardProps> = (props) => {
  if (typeof props.image === 'object') {
    console.warn(
      'passing a JSX element is deprecated. pass the image source as as string'
    );
  }
  if (typeof props.footer === 'object') {
    console.warn('Passing JSX.Element is deprecated. Please pass a string');
  }

  return {
    image: {
      properties: {
        image: resolvePropObjectKeys(props.image, 'props.src', '')
      }
    },
    size: {
      defaultValue: 'xtra-small',
      variations: {
        s: {
          size: 'small'
        },
        m: {
          size: 'medium'
        },
        xs: {
          size: 'xtra-small'
        },
        xxs: {
          size: 'xtra-xtra-small'
        },
        l: {
          size: 'large'
        },
        xl: {
          size: 'xtra-large'
        }
      }
    }
  };
};
